define('core/extensions/helpers/ge',[],function () {
    'use strict';

    return function (a, b) {
        return a >= b;
    };
});

